// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__8q+X4","gallery":"Projects_gallery__bEZ0K"};